<template>
  <b-row>
    <b-col
      md="4"
      class="my-1"
    >
      <b-form-group
        label="Clasificar"
        label-for="sortBySelect"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-select
            id="sortBySelect"
            v-model="sortBy"
            :options="sortOptions"
            class="w-75"
          >
            <template v-slot:first>
              <option value="">
                -- none --
              </option>
            </template>
          </b-form-select>
          <b-form-select
            v-model="sortDesc"
            size="sm"
            :disabled="!sortBy"
            class="w-25"
          >
            <option :value="false">
              ASC
            </option>
            <option :value="true">
              DESC
            </option>
          </b-form-select>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      md="4"
      class="my-1"
    />
    <b-col
      md="4"
      class="my-1"
    >
      <b-form-group
        :label="`Coincidencias [ ${totalRows} ]`"
        label-align-sm="right"
        label-for="filterInput"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="Buscar.."
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              Limpiar
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :sticky-header="true"
        :no-border-collapse="true"
        :items="datos"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >

        <template #cell(fecha)="data">
          <b-media vertical-align="center">
            <small>{{ data.item.fecha }}</small>
          </b-media>
        </template>
        <!-- aportaciones -->
        <template #cell(pagos)="row">
          <b-badge :variant="frmAbonos(row.item).color">
            <feather-icon
              :icon="frmAbonos(row.item).icon"
              class="mr-25"
            />
            {{ frmAbonos(row.item).text }}
          </b-badge>
        </template>
        <!-- status -->
        <template #cell(status)="row">
          <b-badge :variant="frmstatus(row.item.status).color">
            {{ frmstatus(row.item.status).text }}
          </b-badge>
        </template>
        <!-- tipo de beca -->
        <template #cell(beca)="data">
          <b-media vertical-align="center">
            <small>{{ (data.item.beca) ? data.item.abrev+' | '+data.item.beca : 'N/A' }}</small>
          </b-media>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  // BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BMedia,
} from 'bootstrap-vue'
import {
  onMounted,
  ref,
  computed,
} from '@vue/composition-api'
import { frmstatus, frmAbonos } from '@core/utils/filter'

export default {
  components: {
    BTable,
    // BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    // BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BMedia,
  },
  props: {
    datos: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    // variables
    // const perPage = ref(5)
    // const pageOptions = ref([5, 10, 25, 50, 100])
    const totalRows = ref(1)
    // const currentPage = ref(1)
    const sortBy = ref(null)
    const sortDesc = ref(false)
    // const sortDirection = ref('asc')
    const filter = ref(null)
    const filterOn = ref([])
    const infoModal = ref({
      id: 'info-modal',
      title: '',
      content: '',
    })
    const tableColumns = ref([
      { key: 'id', label: 'orden', sortable: true },
      { key: 'fecha', label: 'Registrado', sortable: true },
      {
        key: 'precioFinal', label: 'Aportacion', sortable: true, formatter: val => `$${val}`,
      },
      { key: 'status' },
      { key: 'referencia', label: 'Referencia' },
      // { key: 'limitePago', label: 'limitePago', sortable: true },
      { key: 'beca', label: 'Beca?' },
      { key: 'pagos', label: 'Pagos' },
      'observaciones',
    ])

    // methods
    const sortOptions = computed(() =>
    // Create an options list from our fields
    // eslint-disable-next-line implicit-arrow-linebreak
      tableColumns.value.filter(f => f.sortable).map(f => ({ text: f.label, value: f.key })))

    const onFiltered = filteredItems => {
    // Trigger pagination to update the number of buttons/pages due to filtering
      totalRows.value = filteredItems.length
    }

    onMounted(() => {
      // Set the initial number of items
      totalRows.value = props.datos.length
    })

    return {
      // values
      // perPage,
      // pageOptions,
      totalRows,
      // currentPage,
      sortBy,
      sortDesc,
      // sortDirection,
      filter,
      filterOn,
      infoModal,
      // status,
      tableColumns,
      sortOptions,
      // tasks
      frmstatus,
      frmAbonos,
      onFiltered,

    }
  },
}
</script>
